export * from './lib/pages/payment-method/payment-method.component';
export * from './lib/payment-method.routes';
